import { Component } from '@inter-ikea-core/core';

/**
 * Component added to the collider boxes along the help lines
 */
export default class HelpLinesBoxColliderComponent implements Component {
  static id = 2050;
  typeId = HelpLinesBoxColliderComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return true;
  }
}
